// @flow

import { canUseDOM } from "./utils";

type HotJarType = ((action: string, name: string) => void);

// Ensure HotJar is available
export const ensure = (): ?HotJarType => {
	if(!canUseDOM())
		return null;

	// Trigger the custom HJ event see https://help.hotjar.com/hc/en-us/articles/115015712548-Using-JavaScript-Triggers-to-Start-Recordings
	/* eslint-disable no-undef */
	// Ensure HJ exists
	window.hj = window.hj || function() {
		// $FlowIgnore
		(hj.q = hj.q || []).push(arguments);
	};

	return window.hj;
};

// Proxy call to HotJar's trigger method
export const trigger = (name: string) => {
	let hj = ensure();
	if(hj) {
		hj("trigger", name);
	}
};

// Proxy the call to HotJar
export default (...args: any[]) => {
	let hj = ensure();
	if(hj) {
		hj.apply(hj, args);
	}
};
